// extracted by mini-css-extract-plugin
export default {"container":"Display_container__Ntf6q"};